<template>
    <section
        class="testimonial section center-content"
        :class="[
            topOuterDivider && 'has-top-divider',
            bottomOuterDivider && 'has-bottom-divider',
            hasBgColor && 'has-bg-color',
            invertColor && 'invert-color'
        ]">
        <div class="container-xs">
            <div
                class="testimonial-inner section-inner"
                :class="[
                    topDivider && 'has-top-divider',
                    bottomDivider && 'has-bottom-divider'
                ]">
                <c-section-header :data="sectionHeader" class="center-content" />
                <c-carousel
                    class="tiles-wrap reveal-scale-down"
                    :class="[
                        pushLeft && 'push-left',
                    ]"
                    autorotate
                    :autorotate-timing="10000">
                    <c-carousel-item class="tiles-item">
                        <div class="tiles-item-inner">
                            <div class="testimonial-item-content">
                                <p class="m-0 h4">
                                    "I can no longer imagine what my QA workflow would look like without Pixtel. I'm just able to explain things on my screen so much faster."
                                </p>
                            </div>
                        </div>
                    </c-carousel-item>

                    <c-carousel-item class="tiles-item">
                        <div class="tiles-item-inner">
                            <div class="testimonial-item-content">
                                <p class="m-0 h4">
                                    "Quit looking for recent screenshots and just take them, edit them, and put them where they matter with the same thing. This is great."
                                </p>
                            </div>
                        </div>
                    </c-carousel-item>

                    <c-carousel-item class="tiles-item">
                        <div class="tiles-item-inner">
                            <div class="testimonial-item-content">
                                <p class="m-0 h4">
                                    "There's probably half this thing I haven't even seen yet, and it's already the single most powerful screenshot tool I've seen by a mile."
                                </p>
                            </div>
                        </div>
                    </c-carousel-item>
                </c-carousel>
            </div>
        </div>
    </section>
</template>

<script>
import { SectionTilesProps } from '@/utils/SectionProps.js'
import CSectionHeader from '@/components/sections/partials/SectionHeader.vue'
import CCarousel from '@/components/elements/Carousel.vue'
import CCarouselItem from '@/components/elements/CarouselItem.vue'

export default {
  name: 'CTestimonialCarusel',
  components: {
    CSectionHeader,
    CCarousel,
    CCarouselItem
  },
  mixins: [SectionTilesProps],
  data() {
    return {
      sectionHeader: {
        title: '',
        paragraph: ''
      }
    }
  }
}
</script>